import Modal from 'lib/components/modal/Modal';
import SettingsTypesForm from 'modules/settings/components/settings-types-form/SettingsTypesForm';
import './SettingsSourceTypesInputModal.scss';

const SettingsSourceTypesInputModal = ({
  isOpen,
  addType,
  onRequestClose,
  onChange,
  onSubmit,
  ...props
}) => {
  return (
    <Modal
      title='Add source type'
      className='settings-source-types-modal'
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      data-testid='SettingsSourceTypesInputModal.modal'
      {...props}
    >
      <SettingsTypesForm
        addType={addType}
        onChange={onChange}
        onSubmit={onSubmit}
        cancelForm={onRequestClose}
      />
    </Modal>
  );
};

export default SettingsSourceTypesInputModal;
